(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.LocaleController = (function(superClass) {
    extend(LocaleController, superClass);

    function LocaleController(scope, transitions, modalInstance, userData, locales, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.save = bind(this.save, this);
      LocaleController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Set Locale';
      this.scope.user = userData;
      this.scope.new_locale = null;
      this.scope.received_data = (userData != null) && (locales != null);
      this.scope.locale_collection = _.chunk(locales, 3);
      this.scope.changeLocale = (function(_this) {
        return function(locale) {
          _this.scope.new_locale = locale.id;
          return _this.scope.user.locales_id = locale.id;
        };
      })(this);
    }

    LocaleController.prototype.save = function() {
      this.scope.setAlert({
        msg: 'Updating Locale...',
        type: 'info'
      });
      return this.service.setLocale(this.scope.new_locale).then((function(_this) {
        return function(response) {
          _this.scope.new_locale = null;
          _this.closeWithAlert(response.data.status, response.data.data);
          return location.reload();
        };
      })(this));
    };

    return LocaleController;

  })(DialogController);

}).call(this);
